module.exports = __webpack_public_path__ + "static/media/yellow-card.6abb432d.svg";